module.exports = __webpack_public_path__ + "img/54_13.33f45cb1.png";